export default __webpack_public_path__ + "static/media/T130_CoC.cce33cee.pdf";